/** True during `sku start` / local development builds. */
export const isLocalDemoMode = (): boolean =>
  process.env.NODE_ENV === 'development';
